import { useDispatch, useSelector } from "react-redux";

import { useEffect, useState } from "react";
import $ from "jquery";
import Swal from "sweetalert2";
import LoaderAHSF from "../../Components/LoaderAHSF";
import ButtonAHSF from "../../Components/ButtonAHSF";
import InputAHSF from "../../Components/InputAHSF";
import { setRefreshTable } from "../../Redux/Reducers/VariousVariables";

import TextAreaAHSF from "../../Components/TextAreaAHSF";
import {
  AddSuccessStoryData,
  GetOneSuccessStory,
  restValidateSuccessStory,
  UpdateGetListSuccessStoryData,
  ValidateSuccessStory,
} from "../../Redux/Reducers/ReportStage/SuccessStory";
import { useParams } from "react-router-dom";
import { decryptToken } from "../../Services/Account/EncryptionParams";

const AddEditSuccessStory = (props) => {
  const dispatch = useDispatch();
  let { stageGuid } = useParams();

  stageGuid = decryptToken(stageGuid);
  const state = useSelector((state) => {
    return {
      //////////////////////////////////////////////////////////

      OneSuccessStory: state.SuccessStory.OneSuccessStory,
      UpdateSuccessStory: state.SuccessStory.UpdateSuccessStory,
      SuccessStoryValidate: state.SuccessStory.SuccessStoryValidate,
      loadingOneSuccessStory: state.SuccessStory.loadingOneSuccessStory,
    };
  });

  console.log(state.ChallengesEncounteredThatAffectedValidate, "hhh");

  // State for the project admin form

  const [SuccessStoryList, setSuccessStoryList] = useState({
    pR_successStoriesId: state.OneSuccessStory?.pR_successStoriesId,
    nameOfPersonConcerned: state.OneSuccessStory?.nameOfPersonConcerned,
    successStoryDetails: state.OneSuccessStory?.successStoryDetails,
    quotationsFromPersonConcerned:
      state.OneSuccessStory?.quotationsFromPersonConcerned,

    pR_ReportsStagesGuid: stageGuid,
  });

  // Function to update an existing project management team member

  const AddSuccessStory = async () => {
    const validationList = await dispatch(
      ValidateSuccessStory({
        nameOfPersonConcerned: SuccessStoryList.nameOfPersonConcerned,
        successStoryDetails: SuccessStoryList.successStoryDetails,
        quotationsFromPersonConcerned:
          SuccessStoryList.quotationsFromPersonConcerned,
      })
    );
    //console.log(validationList, validationList.payload.length, "bnbnmbnmb");
    // If no validation errors, add team member
    if (validationList.payload.length === 0) {
      await dispatch(
        AddSuccessStoryData({
          nameOfPersonConcerned: SuccessStoryList.nameOfPersonConcerned,
          successStoryDetails: SuccessStoryList.successStoryDetails,
          quotationsFromPersonConcerned:
            SuccessStoryList.quotationsFromPersonConcerned,
          pR_ReportsStagesGuid: SuccessStoryList.pR_ReportsStagesGuid,
        })
      );
      $(".close-btn").trigger("click");
      Swal.fire({
        position: "center",
        icon: "success",
        title: "تم اضافة المعلومات بنجاح",
        showConfirmButton: false,
        timer: 1500,
        // width: "500px",
      });
      dispatch(setRefreshTable());
    }
  };

  const UpdateSuccessStory = async () => {
    const validationList = await dispatch(
      ValidateSuccessStory({
        nameOfPersonConcerned: SuccessStoryList.nameOfPersonConcerned,
        successStoryDetails: SuccessStoryList.successStoryDetails,
        quotationsFromPersonConcerned:
          SuccessStoryList.quotationsFromPersonConcerned,
      })
    );
    // If no validation errors, update team member
    if (validationList.payload.length === 0) {
      await dispatch(
        UpdateGetListSuccessStoryData({
          pR_successStoriesId: SuccessStoryList.pR_successStoriesId,
          nameOfPersonConcerned: SuccessStoryList.nameOfPersonConcerned,
          successStoryDetails: SuccessStoryList.successStoryDetails,
          quotationsFromPersonConcerned:
            SuccessStoryList.quotationsFromPersonConcerned,

          pR_ReportsStagesGuid: SuccessStoryList.pR_ReportsStagesGuid,
        })
      );
      $(".close-btn").trigger("click");
      Swal.fire({
        position: "center",
        icon: "success",
        title: "تم تعديل المعلومات بنجاح",
        showConfirmButton: false,
        timer: 1500,
        // width: "500px",
      });
      dispatch(setRefreshTable());
    }
  };
  useEffect(() => {
    dispatch(restValidateSuccessStory());
  }, []);
  useEffect(() => {
    if (props != null) {
      dispatch(GetOneSuccessStory(props.pR_successStoriesId));
    }
  }, [props.pR_successStoriesId]);
  useEffect(() => {
    if (!state.loadingOneSuccessStory && Object.keys(props).length != 0) {
      setSuccessStoryList({
        ...state.OneSuccessStory,
      });
    } else {
      setSuccessStoryList({
        nameOfPersonConcerned: null,
        successStoryDetails: null,
        quotationsFromPersonConcerned: null,
        pR_ReportsStagesGuid: SuccessStoryList.pR_ReportsStagesGuid,
      });
    }
  }, [state.OneSuccessStory]);

  //   const shouldDisableFields = !(

  //     (
  //       state.ActiveRound == state.ApplicationInformation?.aI_RoundYearId &&
  //       state.ApplicationInformation?.aI_ApplicationStatus?.canEdite &&
  //       window.location.href.includes("manager") == false
  //     )
  //   );
  //to render html after loading ends
  return (
    <>
      {!state.loadingOneSuccessStory ? (
        <>
          <div className="AddEdite">
            <InputAHSF
              fieldsName="nameOfPersonConcerned"
              show={true}
              disabled={props.shouldDisableFields}
              onChange={(e) => {
                setSuccessStoryList({
                  ...SuccessStoryList,
                  nameOfPersonConcerned: e.target.value,
                });
              }}
              defaultValue={
                state.OneSuccessStory?.nameOfPersonConcerned
                // OpportunitiesObtainedList?.entityProvidingOpportunity
              }
              showValidationMessage={
                state.SuccessStoryValidate
                  ? state.SuccessStoryValidate.includes("nameOfPersonConcerned")
                  : false
              }
              validationMessage="يرجى تعبئة هذا الحقل"
            />
            <TextAreaAHSF
              fieldsName="successStoryDetails"
              show={true}
              disabled={props.shouldDisableFields}
              onChange={(e) => {
                setSuccessStoryList({
                  ...SuccessStoryList,
                  successStoryDetails: e.target.value,
                });
              }}
              defaultValue={SuccessStoryList?.successStoryDetails}
              showValidationMessage={
                state.SuccessStoryValidate
                  ? state.SuccessStoryValidate.includes("successStoryDetails")
                  : false
              }
              validationMessage="يرجى تعبئة هذا الحقل"
            />
            <TextAreaAHSF
              fieldsName="quotationsFromPersonConcerned"
              show={true}
              disabled={props.shouldDisableFields}
              onChange={(e) => {
                setSuccessStoryList({
                  ...SuccessStoryList,
                  quotationsFromPersonConcerned: e.target.value,
                });
              }}
              defaultValue={SuccessStoryList?.quotationsFromPersonConcerned}
              showValidationMessage={
                state.SuccessStoryValidate
                  ? state.SuccessStoryValidate.includes(
                      "quotationsFromPersonConcerned"
                    )
                  : false
              }
              validationMessage="يرجى تعبئة هذا الحقل"
            />
            {!props.shouldDisableFields ? (
              <div className="containersButton">
                <div>
                  <ButtonAHSF
                    type={"submitter"}
                    onClick={() => {
                      props.canEdit == "edit"
                        ? UpdateSuccessStory()
                        : AddSuccessStory();
                    }}
                    disabled={false}
                    title={Object.keys(props).length == 0 ? "إضافة" : "تعديل"}
                    text={Object.keys(props).length == 0 ? "إضافة" : "تعديل"}
                    show={true}
                  />
                </div>
              </div>
            ) : (
              ""
            )}
          </div>
        </>
      ) : (
        ""
      )}
      <LoaderAHSF show={state.loadingOneSuccessStory} />
    </>
  );
};

export default AddEditSuccessStory;
